import {defineAsyncComponent} from 'vue'
const ResourcesRouter = [
  {
    path: 'resources',
    name: 'Resources',
    redirect: 'ResourcesManage',
    meta: {
      key: 'resources'
    },
    children: [
      {
        path: 'manage',
        name: 'ResourcesManage',
        component: () => import('@/views/Resource/Manage.vue'),
        meta: {
          key: 'resources'
        }
      },
      {
        path: 'pkgs',
        name: 'ResourcesPkgs',
        component: () => import('@/views/Resource/Pkgs.vue'),
        meta: {
          key: 'resources'
        }
      },
      {
        path: 'links',
        name: 'ResourcesLinks',
        component: () => import('@/views/Resource/Links.vue'),
        meta: {
          key: 'resources'
        }
      },
    ]
  },
  
]
export {ResourcesRouter}
